export const state = () => ({
  collection: [],
  pages: 0,
  total: 0,
  per_page: 100,
})

export const mutations = {
  SET_WORK(state, payload) {
    state.collection = payload
  },
  SET_PAGES(state) {
    state.pages = Math.ceil(state.total / state.per_page)
  },
  SET_PER_PAGE(state, payload) {
    state.per_page = payload
  },
  SET_TOTAL(state, payload) {
    state.total = payload
  },
}

export const getters = {}

export const actions = {
  async getWork({ commit, dispatch, state }, payload) {
    dispatch('loading/startBusyState', null, { root: true })
    return await this.$storyapi
      .get('cdn/stories', {
        starts_with: payload.route,
        page: payload.index || 1,
        per_page: payload.per_page,
        version: 'published',
        is_startpage: 0,
        ...payload.params,
      })
      .then((res) => {
        dispatch('loading/stopBusyState', null, { root: true })
        if (!state.total) {
          commit('SET_TOTAL', res.total)
        }
        return res.data.stories
      })
      .catch((res) => {
        return res
      })
  },
  async getAllWork({ commit, dispatch, state }, payload) {
    const collection = []

    commit('SET_PER_PAGE', payload.per_page)
    await dispatch('getWork', {
      per_page: 1,
      route: payload.route,
      params: payload.params,
    })
    commit('SET_PAGES')

    for (let i = 1; i <= state.pages; i++) {
      const results = await dispatch('getWork', {
        per_page: state.per_page,
        index: i,
        route: payload.route,
        params: payload.params,
      })
      collection.push(...results)
    }
    commit('SET_WORK', collection)
  },
}
